







































































































































































































































import { Component, Vue } from "vue-property-decorator";
import CategoriesApi from "@/services/CategoriesApi";
import UgcsApi from "@/services/Ugcs";
import { Category, NewCategory, UpdateCategory } from "@/api/lab-base-api-client";
import CategoryModule from "@/store/category";
import { ValidationObserver } from "vee-validate";
import { generateFileReader } from "@/utils/Util";
import logger from "@/lib/log/logger";

@Component
export default class MMaterialRegisterCategory extends Vue {
  // category一覧
  private categories: Category[] = [];

  // 削除・編集の対象categoryId
  private targetItemId = -1;

  // imgのinput初期値
  private image = [];

  // inputの初期値
  private items: NewCategory = { name: "", slug: "", ugcUuid: "" };

  private editItems: UpdateCategory = { name: "", slug: "", ugcUuid: "" };

  // items,editItemsの初期化用
  private defaultItems: NewCategory = { name: "", slug: "", ugcUuid: "" };

  // checkboxの初期値
  private categoryId: number | null | false = null;

  // imgPreviewのurl
  private ugcUrl = "";

  // categoryのimageUrl
  private imgUrl = "";

  // ダイアログ
  private isCreateDialog = false;

  private isEditDialog = false;

  private isDeleteDialog = false;

  // categoryのcheckboxからcategoryIdを取得
  public getCategoryId(event: number | null) {
    CategoryModule.changeCategoryId(event);
  }

  // ページ読み込み時に実行
  private async mounted() {
    await this.fetch();
    this.setId();
  }

  // 教材編集だった場合uuidをセット
  private setId() {
    if (this.$route.name === "MaterialEdit") {
      this.categoryId = Number(this.$route.query.cat);
    }
  }

  // category一覧取得
  private async fetch() {
    const categoriesRes = await CategoriesApi.instance.getCategories();
    this.categories = categoriesRes.data.data.categories;
  }

  // imgのpreview
  /**
   * v-file-inputで選択したimageのプレビューを表示
   * 公式でchangeイベントの型はFile[]だが、ここでは単一のファイルしか使用しないためFileとして定義する
   */
  private previewFile(file: File) {
    if (!file) {
      this.ugcUrl = "";
    }
    const reader = generateFileReader(file);
    if (reader) {
      reader.addEventListener("load", () => {
        if (reader.result instanceof ArrayBuffer) {
          this.ugcUrl = reader.result.toString();
        } else if (reader.result) {
          this.ugcUrl = reader.result;
        }
      });
    }
  }

  // 「NEW ITEM」クリックで実行
  private async onCreateItem() {
    this.isCreateDialog = true;
  }

  // Createダイアログダイアログの[ok」クリックで実行
  private async CreateItem() {
    await this.createCategory();
    this.closeCreateDialog();
    await this.fetch();
  }

  // Ugc作成
  private async createUgc() {
    try {
      const ugcRes = await UgcsApi.instance.createUGC(this.image);
      if (ugcRes.data.data?.ugc?.uuid === undefined) {
        logger.frontError("failed get material");
        throw new Error("failed create ugc");
      }
      return ugcRes.data.data.ugc;
    } catch (err) {
      if (err instanceof Error) {
        logger.frontError(`${err.name}: ${err.message}`);
        console.log(err);
      }

      throw err;
    }
  }

  // カテゴリー作成
  private async createCategory() {
    try {
      if (this.image && this.image.length === undefined) {
        const ugc = await this.createUgc();
        this.items.ugcUuid = ugc.uuid;
      }

      await CategoriesApi.instance.createCategory(this.items);
    } catch (err) {
      if (err instanceof Error) {
        logger.frontError(`${err.name}: ${err.message}`);
        console.log(err);
      }
    }
  }

  // Createダイアログを閉じる
  private async closeCreateDialog() {
    this.isCreateDialog = false;
    this.items = { ...this.defaultItems };
    this.ugcUrl = "";
    this.image = [];
    // バリデーションリセット
    (this.$refs.observer as InstanceType<typeof ValidationObserver>).reset();
  }

  // 「EDIT ITEM」クリックで実行
  private async onEditItem() {
    if (this.categoryId) {
      this.targetItemId = this.categoryId;
      const categoryRes = await CategoriesApi.instance.getCategoryById(this.categoryId);

      if (categoryRes.data.data.category) {
        const { category } = categoryRes.data.data;
        this.editItems.name = category.name;
        this.editItems.slug = category.slug;
        this.editItems.ugcUuid = category.ugcUuid;
        if (this.editItems.ugcUuid !== null && category.ugc) {
          this.imgUrl = category.ugc.url;
        } else {
          this.imgUrl = "";
        }
        this.isEditDialog = true;
      }
    }
  }

  // Editダイアログの「ok」クリックで実行
  private async editItem() {
    if (this.image && this.image.length === undefined) {
      const ugc = await this.createUgc();
      this.editItems.ugcUuid = ugc.uuid;
    }
    await this.updateCategory();
    this.closeEditDialog();
    await this.fetch();
  }

  // カテゴリー更新
  private async updateCategory() {
    try {
      await CategoriesApi.instance.updateCategoryById(this.targetItemId, this.editItems);
    } catch (err) {
      if (err instanceof Error) {
        logger.frontError(`${err.name}: ${err.message}`);
        console.log(err);
      }
    }
  }

  // Editダイアログを閉じる
  private closeEditDialog() {
    this.isEditDialog = false;
    this.ugcUrl = "";
    this.image = [];
    this.categoryId = false;
  }

  // 「DELETE」クリックで実行
  private async onDeleteItem() {
    if (this.categoryId === false || this.categoryId === null) {
      return;
    }
    this.isDeleteDialog = true;
    this.targetItemId = this.categoryId;
  }

  // Deleteダイアログの[ok」クリックで実行
  private async deleteItem() {
    await this.deleteCategory();
    this.closeDeleteDialog();
    this.fetch();
  }

  // カテゴリー削除
  private async deleteCategory() {
    try {
      await CategoriesApi.instance.deleteCategoryById(this.targetItemId);
    } catch (err) {
      if (err instanceof Error) {
        logger.frontError(`${err.name}: ${err.message}`);
        console.log(err);
      }
    }
  }

  // Deleteダイアログを閉じる
  private closeDeleteDialog() {
    this.isDeleteDialog = false;
    this.categoryId = false;
  }
}
